import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import styled from 'styled-components';
import { isNil, get } from 'lodash';
import { Paper, TextField } from '@material-ui/core';
import { logoSanlamBase64 } from 'components/DesignationLetter/constants';
import { translate } from 'containers/services/translate';
import messages from 'containers/LoginPage/messages';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import PrimaryButton from 'components/Buttons/PrimaryButton';

const Container = styled.div`
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .containerLoginForm {
    width: 440px;
    height: 360px;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .button {
    background-color: ${COLORS.BLUE};
    color: white;
    width: 330px;
    height: 46px;
    &:hover {
      background-color: ${COLORS.BLUE};
    }
    margin-bottom: 46px;
  }
  .title {
    text-align: center;
    font-family: Roboto;
    font-size: 20px;
    font-weight: Medium;
    letter-spacing: 0;
    color: #02194e;
    opacity: 1;
  }
  .subTitle {
    text-align: center;
    font-family: Roboto;
    font-size: 15px;
    font-weight: Regular;
    letter-spacing: 0;
    color: #707891;
    opacity: 1;
  }
  .titleContainer {
    margin-bottom: 40px;
    margin-top: 37px;
  }
  .form {
    width: 350px;
  }
  .input {
    margin-bottom: 33px;
  }
  .logo {
    margin-bottom: 25px;
  }
  #primary-button-style {
    width: 80%;
    margin: 0 auto;
  }
`;

export interface LoginFormProps {
  intl: IntlShape;
  requestLogin: Function;
}

const LoginForm: React.FC<LoginFormProps> = (props): JSX.Element => {
  const [user, updateUser] = React.useState({
    username: '',
    password: '',
  });

  const handleChange = (field: string) => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = event.target;
    let expectedUser: any = {
      username: user.username,
      password: user.password,
    };
    expectedUser[field] = value;
    return updateUser(expectedUser);
  };

  const handleSubmit = (event: React.SyntheticEvent) => {
    const { username, password } = user;
    props.requestLogin({ username, password });
  };
  return (
    <Container>
      <div className="logo">
        <img
          width="200px"
          height="41px"
          src={logoSanlamBase64}
          alt="SanlamAllianz - Logo"
          title="SanlamAllianz"
        />
      </div>
      <Paper className="containerLoginForm">
        <div className="titleContainer">
          <div className="title">
            {translate({ ...messages.loginPageTitle }, props)}
          </div>
          <div className="subTitle">
            {translate({ ...messages.loginPageSubTitle }, props)}
          </div>
        </div>
        <div className="form">
          <TextField
            label={translate({ ...messages.username }, props)}
            name="username"
            type="text"
            value={user.username}
            className="input"
            onChange={handleChange('username')}
            fullWidth
          />
          <TextField
            label={translate({ ...messages.password }, props)}
            name="password"
            type="password"
            value={user.password}
            className="input"
            onChange={handleChange('password')}
            onKeyPress={e => {
              if (
                e.key === 'Enter' &&
                user.password != '' &&
                !isNil(get(user, 'password', null))
              ) {
                handleSubmit(e);
              }
            }}
            fullWidth
          />
        </div>
        <PrimaryButton
          onClick={handleSubmit}
          title={translate({ ...messages.connectionButton }, props)}
          background={BUTTON_COLORS.PRIMARY_BLUE}
          border={BUTTON_COLORS.PRIMARY_BLUE}
          titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
        />
      </Paper>
    </Container>
  );
};

export default injectIntl(LoginForm);
